// The bare identifier, wrapped in an object: synapse's `DefaultPayload` forbids a bare scalar.
export type DocumentTypeRestoredPayload = {
	documentTypeId: number;
};

export type DocumentTypeRestoredAction = {
	type: 'DOCUMENT_TYPE_RESTORED';
	payload: DocumentTypeRestoredPayload;
	accountId: number;
};

export default (payload: DocumentTypeRestoredPayload, accountId: number): DocumentTypeRestoredAction => ({
	type: 'DOCUMENT_TYPE_RESTORED',
	payload,
	accountId,
});
